import { Locale } from 'modules/i18n';

export const publicChainsTranslation = {
  [Locale.en]: {
    requestsTooltip: "All users' Mainnet requests for the last 30 days",
  },
};
